import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ultraadminBillingApi } from '@/services/api/billing'

export function UltraadminOverduePage() {
  const [data, setData] = useState<any>(null)
  const nav = useNavigate()
  useEffect(() => { ultraadminBillingApi.overdue().then(setData) }, [])
  return (
    <div className="p-6 max-w-5xl">
      <h1 className="text-2xl font-bold mb-4">Schulen im Verzug ({data?.count ?? 0})</h1>
      <table className="w-full text-sm">
        <thead><tr className="text-left border-b"><th className="py-2">Schule</th><th>Offen</th><th>Älteste Fälligkeit</th><th>Status</th><th>Tickets</th></tr></thead>
        <tbody>
          {(data?.schools || []).map((s: any) => (
            <tr key={s.school_id} className="border-b cursor-pointer" onClick={() => nav(`/ultraadmin/invoices?school_id=${s.school_id}`)}>
              <td className="py-2">{s.school_name}</td>
              <td>{s.open_amount} {s.currency}</td>
              <td>{s.oldest_due_at}</td>
              <td>{s.is_active ? 'aktiv' : (s.deactivated_reason || 'gesperrt')}</td>
              <td>{s.ticket_lifetime}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
